import { LanguageDropdown as LocalizationLanguageDropdown } from '@faceup/localization'
import { type ForwardedRef, forwardRef } from 'react'
import useManageLanguageDropdown, {
  type UseManageLanguageDropdownProps,
} from '../../hooks/useManageLanguageDropdown'

type LanguageDropdownProps = UseManageLanguageDropdownProps

const LanguageDropdown = forwardRef(
  (
    { availableLanguages, defaultLanguage }: LanguageDropdownProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    const { alphabeticallySortedLanguages, defaultSelectedLanguage, changeLanguage } =
      useManageLanguageDropdown({ availableLanguages, defaultLanguage })

    return (
      <LocalizationLanguageDropdown
        ref={ref}
        activeLanguage={defaultSelectedLanguage}
        languages={alphabeticallySortedLanguages}
        onChangeLanguage={changeLanguage}
        areLanguagesNative
        className='border border-solid border-colorBorder rounded-xl bg-white h-11 px-3'
        styles={{
          targetText: {
            strong: true,
          },
        }}
      />
    )
  }
)

export default LanguageDropdown
